export class DefaultInteraction {

	entity = null

	/**
	 * Interaction key
	 * Should be overridden with unique key
	 */
	key() {
		throw Error("missing interaction key")
	}

	successFn = (data) => {
	}

	errorFn = (e) => {
	}

	setEntity(entity) {
		this.entity = entity;
	}

	/**
	 * Run the interaction
	 *
	 * @param interactionData
	 * @param metadata
	 * @param onSuccess
	 * @param onError
	 * @returns {boolean}
	 */
	interact(interactionData, metadata, onSuccess = () => {}, onError = () => {}) {
		console.log("Default interaction", interactionData, metadata)
		return true
	}

	onSuccess(data = {}) {
		this.successFn(data)
	}

	onError(e) {
		console.error("Interaction error", e)
		this.errorFn(e)
	}

	runInteraction(interactionData, metadata, onSuccess, onError) {
		try {
			if (this.interact(interactionData, metadata, onSuccess, onError))
				onSuccess() //Only called if interaction returns true
		} catch (e) {
			onError(e)
		}
	}

	/**
	 * Called when interaction added to engine
	 *
	 * @param obj
	 * @param interaction
	 */
	onAdd(obj, interaction) {
		//
	}

	/**
	 * Called once per loop for interactions
	 * @param player
	 * @param interactions
	 */
	onUpdate(player, interactions = []) {
		//
	}

	/**
	 * Called once per tick for interactions
	 * @param interactions
	 */
	onTick(interactions = []) {
		//
	}

	/**
	 * Called upon player leaving the proximity of a given interactable
	 * @param interactable
	 */
	onProximityExit(interactable) {
		//
	}

	/**
	 * Called upon player entering the proximity of a given interactable
	 * @param interaction
	 * @param interactable
	 */
	onProximityEnter(interaction, interactable) {
		//
	}

	/**
	 * Returns if the player is in range of a given interactables radius
	 * @param player
	 * @param interactable
	 * @param radius
	 * @returns {boolean}
	 */
	inRange(player, interactable, radius = 2) {
		return this.euclideanDistance(player, interactable) < radius
	}

	/**
	 * Calculate the distance between 2 points
	 * @param p1
	 * @param p2
	 * @returns {number}
	 */
	euclideanDistance(p1, p2) {
		const pos1 = p1.position
		const pos2 = p2.position

		return Math.sqrt((pos1.x - pos2.x) * (pos1.x - pos2.x) + (pos1.z - pos2.z) * (pos1.z - pos2.z))
	}
}